export default __webpack_public_path__ + "static/media/EnjoyGift.ebeea12b.svg";